(function (root, factory) {
  var api = factory(root);

  root.PjDesignLabPrintPpi = api;

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var CONFIG_ID = 'pjDesignLabPrintPpiConfig';
  var DEFAULTS = {
    printInches: 3,
    warnPpi: 200,
    rejectPpi: 200,
    acceptPpi: 300,
    rejectTitle: 'This photo is too small to print clearly',
    rejectBody:
      'Please upload a closer or higher-resolution shot. A small or heavily cropped photo can look soft or blurry on the finished pajamas.',
    warnTitle: 'This photo may print soft',
    warnBody:
      'You can continue, or replace it with a closer or higher-resolution shot so the print stays sharp.',
  };

  function isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function positiveNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function firstText() {
    for (var index = 0; index < arguments.length; index += 1) {
      var value = arguments[index];
      if (value == null) continue;
      var text = String(value).trim();
      if (text) return text;
    }
    return '';
  }

  function parseJson(raw) {
    if (raw == null || raw === '') return null;
    if (isObject(raw) || Array.isArray(raw)) return raw;
    if (typeof raw !== 'string') return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function parseConfig(raw) {
    var parsed = parseJson(raw);
    var source = isObject(parsed) ? parsed : {};
    return {
      printInches: positiveNumber(source.printInches, DEFAULTS.printInches),
      warnPpi: positiveNumber(source.warnPpi, DEFAULTS.warnPpi),
      rejectPpi: positiveNumber(source.rejectPpi, DEFAULTS.rejectPpi),
      acceptPpi: positiveNumber(source.acceptPpi, DEFAULTS.acceptPpi),
      rejectTitle: firstText(source.rejectTitle, DEFAULTS.rejectTitle),
      rejectBody: firstText(source.rejectBody, DEFAULTS.rejectBody),
      warnTitle: firstText(source.warnTitle, DEFAULTS.warnTitle),
      warnBody: firstText(source.warnBody, DEFAULTS.warnBody),
    };
  }

  function effectivePrintPpi(width, height, printInches) {
    var shortest = Math.min(Number(width), Number(height));
    var inches = positiveNumber(printInches, DEFAULTS.printInches);
    if (!Number.isFinite(shortest) || shortest <= 0) return null;
    return shortest / inches;
  }

  function assessPrintPpi(width, height, rawConfig) {
    var config = parseConfig(rawConfig);
    var ppi = effectivePrintPpi(width, height, config.printInches);
    var safePpi = ppi == null ? 0 : ppi;
    var outcome = 'accept';
    if (ppi == null || safePpi < config.rejectPpi) outcome = 'reject';
    else if (safePpi < config.acceptPpi) outcome = 'warn';

    return {
      outcome: outcome,
      width: Number(width) || 0,
      height: Number(height) || 0,
      ppi: safePpi,
      printInches: config.printInches,
      warnPpi: config.warnPpi,
      rejectPpi: config.rejectPpi,
      acceptPpi: config.acceptPpi,
    };
  }

  function messagesFor(assessment, config) {
    var resolved = parseConfig(config);
    if (assessment && assessment.outcome === 'reject') {
      return { title: resolved.rejectTitle, body: resolved.rejectBody };
    }
    if (assessment && assessment.outcome === 'warn') {
      return { title: resolved.warnTitle, body: resolved.warnBody };
    }
    return { title: '', body: '' };
  }

  function readConfig(doc) {
    var target = doc || root.document;
    var node =
      target && typeof target.getElementById === 'function'
        ? target.getElementById(CONFIG_ID)
        : null;
    return parseConfig(node && (node.textContent || node.innerHTML));
  }

  function loadUrlSize(url) {
    return new Promise(function (resolve, reject) {
      if (!url || typeof root.Image === 'undefined') {
        reject(new Error('image-size-unavailable'));
        return;
      }
      var image = new root.Image();
      image.onload = function () {
        var width = image.naturalWidth || image.width;
        var height = image.naturalHeight || image.height;
        if (!width || !height) reject(new Error('image-size-unavailable'));
        else resolve({ width: width, height: height });
      };
      image.onerror = function () {
        reject(new Error('image-size-unavailable'));
      };
      image.src = url;
    });
  }

  function loadImageSize(file) {
    return new Promise(function (resolve, reject) {
      if (!file || typeof root.URL === 'undefined' || typeof root.Image === 'undefined') {
        reject(new Error('image-size-unavailable'));
        return;
      }
      var url = root.URL.createObjectURL(file);
      var image = new root.Image();
      image.onload = function () {
        var width = image.naturalWidth || image.width;
        var height = image.naturalHeight || image.height;
        root.URL.revokeObjectURL(url);
        if (!width || !height) reject(new Error('image-size-unavailable'));
        else resolve({ width: width, height: height });
      };
      image.onerror = function () {
        root.URL.revokeObjectURL(url);
        reject(new Error('image-size-unavailable'));
      };
      image.src = url;
    });
  }

  function logOutcome(assessment, extra) {
    if (!root.console || typeof root.console.info !== 'function') return;
    root.console.info('[PJ Design Lab] print PPI gate', Object.assign({}, assessment, extra || {}));
  }

  function paintSlotMessage(slot, assessment, config) {
    if (!slot || !slot.querySelector) return;
    var existing = slot.querySelector('[data-print-ppi-message]');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    slot.classList.remove('has-print-ppi-warning', 'has-print-ppi-reject');
    if (!assessment || assessment.outcome === 'accept') return;

    var copy = messagesFor(assessment, config);
    var note = (root.document || { createElement: function () { return {}; } }).createElement('p');
    note.setAttribute('data-print-ppi-message', assessment.outcome);
    note.className =
      'photo-upload-ppi-message photo-upload-ppi-message--' + assessment.outcome;
    note.textContent = copy.body;
    if (copy.title) note.setAttribute('title', copy.title);
    slot.classList.add(
      assessment.outcome === 'reject' ? 'has-print-ppi-reject' : 'has-print-ppi-warning'
    );
    var zone = slot.querySelector('.photo-upload-zone') || slot;
    if (zone.classList) {
      if (assessment.outcome === 'warn') zone.classList.add('has-warning');
      else zone.classList.remove('has-warning');
    }
    if (slot.appendChild) slot.appendChild(note);
  }

  function assessmentFromUploadResponse(raw) {
    var parsed = parseJson(raw);
    if (!isObject(parsed)) return null;
    var message = firstText(parsed.message);
    var looksLowRes =
      parsed.code === 'UPLOAD_TOO_LOW_RES' || /too small to print/i.test(message);
    if (!looksLowRes) return null;
    return {
      outcome: 'reject',
      width: Number(parsed.width) || 0,
      height: Number(parsed.height) || 0,
      ppi: Number(parsed.ppi) || 0,
      code: 'UPLOAD_TOO_LOW_RES',
    };
  }

  function paintSlotFromUploadResponse(slot, raw, config) {
    var assessment = assessmentFromUploadResponse(raw);
    if (!assessment) return null;
    paintSlotMessage(slot, assessment, config);
    return assessment;
  }

  function isEnforced(options) {
    if (options && typeof options.enforce === 'boolean') return options.enforce;
    var doc = (options && options.doc) || root.document;
    var el = doc && doc.getElementById && doc.getElementById(CONFIG_ID);
    if (!el || !el.getAttribute) return false;
    var raw = el.getAttribute('data-enforce');
    return raw === 'true' || raw === '1';
  }

  function gateFile(file, options) {
    if (!isEnforced(options)) {
      return Promise.resolve({ outcome: 'skipped', reason: 'not-enforced' });
    }
    var config = (options && options.config) || readConfig(options && options.doc);
    var slot = options && options.slot;
    var petSlot = options && options.petSlot;

    return loadImageSize(file)
      .then(function (size) {
        var assessment = assessPrintPpi(size.width, size.height, config);
        logOutcome(assessment, { petSlot: petSlot });
        paintSlotMessage(slot, assessment, config);
        if (assessment.outcome === 'reject') {
          var error = new Error('UPLOAD_TOO_LOW_RES');
          error.code = 'UPLOAD_TOO_LOW_RES';
          error.assessment = assessment;
          throw error;
        }
        return assessment;
      })
      .catch(function (error) {
        if (error && error.code === 'UPLOAD_TOO_LOW_RES') throw error;
        logOutcome({ outcome: 'skipped', reason: String(error && error.message) }, { petSlot: petSlot });
        return { outcome: 'skipped' };
      });
  }

  return {
    CONFIG_ID: CONFIG_ID,
    DEFAULTS: DEFAULTS,
    parseConfig: parseConfig,
    isEnforced: isEnforced,
    effectivePrintPpi: effectivePrintPpi,
    assessPrintPpi: assessPrintPpi,
    messagesFor: messagesFor,
    readConfig: readConfig,
    gateFile: gateFile,
    paintSlotMessage: paintSlotMessage,
    assessmentFromUploadResponse: assessmentFromUploadResponse,
    paintSlotFromUploadResponse: paintSlotFromUploadResponse,
    loadUrlSize: loadUrlSize,
  };
});
